import { useState } from 'react';
import { faqs } from '@/mocks/homeData';
import SectionHeading from './SectionHeading';

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number>(0);

  return (
    <section id="faq" className="w-full px-4 md:px-8 py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-6xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          <div className="lg:col-span-1">
            <SectionHeading
              eyebrow="常见问题 FAQ"
              title="黑料导航常见问题，逐条说清"
              desc="这里汇总了使用过程中最常被问到的几个问题，展开即可查看说明。"
            />
            <div className="mt-6 bg-background-100 border border-background-200 rounded-lg p-5">
              <div className="flex items-center gap-2 text-primary-700">
                <i className="ri-lightbulb-line text-xl"></i>
                <span className="font-heading text-base">小提示</span>
              </div>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                若你的问题不在列表里，可以直接在页面下方提交反馈，帮助中心会视情况补充说明。
              </p>
            </div>
          </div>

          <div className="lg:col-span-2 space-y-3">
            {faqs.map((item, index) => {
              const open = openIndex === index;
              return (
                <div
                  key={item.q}
                  className={`rounded-lg border transition-colors ${
                    open ? 'bg-background-100 border-primary-300' : 'bg-background-50 border-background-200'
                  }`}
                >
                  <button
                    type="button"
                    onClick={() => setOpenIndex(open ? -1 : index)}
                    className="w-full flex items-center justify-between gap-4 px-4 md:px-5 py-4 text-left cursor-pointer"
                  >
                    <span className="flex items-start gap-3">
                      <span className="font-heading text-primary-600 text-lg leading-none mt-0.5">
                        {String(index + 1).padStart(2, '0')}
                      </span>
                      <span className="text-sm md:text-base text-foreground-950 leading-snug">{item.q}</span>
                    </span>
                    <span
                      className={`shrink-0 w-8 h-8 rounded-md flex items-center justify-center transition-colors ${
                        open ? 'bg-primary-500 text-background-50' : 'bg-background-200 text-foreground-700'
                      }`}
                    >
                      <i className={open ? 'ri-subtract-line' : 'ri-add-line'}></i>
                    </span>
                  </button>
                  {open && (
                    <div className="px-4 md:px-5 pb-4">
                      <p className="text-sm text-foreground-600 leading-relaxed border-t border-background-200 pt-4">
                        {item.a}
                      </p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}